module.exports = __webpack_public_path__ + "1_0_65/img/backspace.7f99dabe.svg";